const url = localStorage.getItem("URL");

export default url;
